import React from 'react';

import SvgContainer from '../SvgContainer';

const ArrowUp = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100953)">
                <path d="M13.8126 12.1972C14.2234 12.6328 14.916 12.6328 15.3267 12.1972C15.7048 11.7963 15.7048 11.1702 15.3267 10.7694L8.72753 3.77148C8.33281 3.35292 7.66719 3.35292 7.27247 3.77148L0.67325 10.7694C0.295208 11.1702 0.295209 11.7963 0.673251 12.1972C1.08398 12.6328 1.77662 12.6328 2.18735 12.1972L8 6.03342L13.8126 12.1972Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100953">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default ArrowUp;
